import {createSelector, MemoizedSelector} from '@ngrx/store';
import {
  ingenierosAgronomosAdapter,
  IngenierosAgronomosState
} from './ingenieros-agronomos.state';

import {FeaturesState, selectFeatures} from '../../../features.state';
import {IngenieroAgronomoCore} from "../../../../../chacra-core/models/ingenieros-agronomos";

export const getError = (state: IngenierosAgronomosState): any =>
  state.error;

export const getIsLoading = (state: IngenierosAgronomosState): boolean =>
  state.isLoading;

export const selectIngenierosAgronomosState = createSelector(selectFeatures,
  (state: FeaturesState) => state.ingenierosAgronomos
);

export const selectAllIngenierosAgronomos: (state: object) => IngenieroAgronomoCore[] =
  ingenierosAgronomosAdapter.getSelectors(selectIngenierosAgronomosState).selectAll;

export const selectIngenieroAgronomoById = (id: string) =>
  createSelector(
    selectAllIngenierosAgronomos,
    (allIngenierosAgronomos: IngenieroAgronomoCore[]) => {
      if (allIngenierosAgronomos) {
        return allIngenierosAgronomos.find(p => p.ingenieroAgronomoId === id);
      } else {
        return null;
      }
    }
  );

export const selectIngenierosAgronomosError: MemoizedSelector<object, any> = createSelector(
  selectIngenierosAgronomosState,
  getError
);

export const selectIngenierosAgronomosIsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectIngenierosAgronomosState,
  getIsLoading
);
